<section
  class="py-12 sm:py-16 lg:py-24 border-b transition-colors"
  [ngClass]="theme === 'warm' ? 'bg-[#fffdfa] border-stone-200 text-stone-900' : (theme === 'bold' ? 'bg-slate-900 text-white border-blue-900/60' : 'bg-base-100 border-base-300')"
>
  <div class="container mx-auto px-4 sm:px-6 max-w-6xl">
    
    <!-- Section Header -->
    <div class="text-center max-w-2xl mx-auto mb-8 sm:mb-14">
      <div
        class="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3"
        [ngClass]="theme === 'warm' ? 'bg-amber-500/15 text-amber-900 border border-amber-400/40' : (theme === 'bold' ? 'bg-red-600/20 text-red-300 border border-red-500/40' : 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400')"
      >
        <i class="fa-solid fa-gift"></i>
        <span>Included Perks</span>
      </div>
      <h2
        class="text-2xl sm:text-4xl font-extrabold tracking-tight break-words px-2"
        [ngClass]="theme === 'warm' ? 'text-stone-900' : (theme === 'bold' ? 'text-white' : 'text-base-content')"
      >
        {{ title }}
      </h2>
      <p
        class="text-sm sm:text-base mt-3 leading-relaxed px-2"
        [ngClass]="theme === 'warm' ? 'text-stone-600' : (theme === 'bold' ? 'text-slate-300' : 'text-base-content/70')"
      >
        Everything you need to excel in your examinations, included standard with all batch subscriptions.
      </p>
    </div>

    <!-- Perks Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
      @for (perk of perkItems; track $index) {
        <div
          class="daisy-card border p-5 sm:p-8 rounded-2xl sm:rounded-3xl transition-all space-y-2.5 sm:space-y-3"
          [ngClass]="theme === 'warm' ? 'bg-[#faf6f0] border-stone-200 hover:border-amber-400 hover:shadow-md' : (theme === 'bold' ? 'bg-slate-800/90 border-slate-700 hover:border-blue-500 shadow-lg text-white' : 'bg-base-200/40 border-base-300 hover:border-primary/40 hover:shadow-lg')"
        >
          <div
            class="w-10 h-10 sm:w-12 sm:h-12 rounded-xl sm:rounded-2xl flex items-center justify-center text-lg sm:text-xl shrink-0"
            [ngClass]="theme === 'warm' ? 'bg-amber-500/15 text-amber-700' : (theme === 'bold' ? 'bg-blue-500/20 text-blue-400' : 'bg-primary/10 text-primary')"
          >
            <i [class]="perk.icon || 'fa-solid fa-circle-check'"></i>
          </div>
          <h3 class="text-base sm:text-lg font-bold" [ngClass]="theme === 'warm' ? 'text-stone-900' : (theme === 'bold' ? 'text-white' : 'text-base-content')">
            {{ perk.title }}
          </h3>
          @if (perk.desc) {
            <p class="text-xs sm:text-sm leading-relaxed" [ngClass]="theme === 'warm' ? 'text-stone-600' : (theme === 'bold' ? 'text-slate-300' : 'text-base-content/70')">
              {{ perk.desc }}
            </p>
          }
        </div>
      }
    </div>

  </div>
</section>
